interface CategoryFilterProps {
  readonly categories: readonly string[];
  readonly selected: string | null;
  readonly onSelect: (category: string | null) => void;
}

export const CategoryFilter = ({
  categories,
  selected,
  onSelect,
}: CategoryFilterProps) => {
  return (
    <div className="flex flex-wrap" style={{ gap: 'var(--space-2)' }}>
      <FilterPill
        isActive={selected === null}
        onClick={() => onSelect(null)}
      >
        All
      </FilterPill>
      {categories.map((category) => (
        <FilterPill
          key={category}
          isActive={selected === category}
          onClick={() => onSelect(category)}
        >
          {category}
        </FilterPill>
      ))}
    </div>
  );
};

const FilterPill = ({
  isActive,
  onClick,
  children,
}: {
  isActive: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) => (
  <button
    type="button"
    onClick={onClick}
    className="focus-ring filter-pill"
    style={{
      borderRadius: 'var(--radius-full)',
      padding: 'var(--space-2) var(--space-4)',
      fontSize: 'var(--text-sm)',
      fontWeight: 'var(--font-weight-medium)',
      border: 'none',
      cursor: 'pointer',
      backgroundColor: isActive ? 'var(--color-primary-600)' : 'var(--bg-surface-sunken)',
      color: isActive ? 'var(--text-inverse)' : 'var(--text-secondary)',
      transition: `all var(--duration-fast) var(--ease-out)`,
      minHeight: '36px',
      display: 'inline-flex',
      alignItems: 'center',
    }}
  >
    {children}
  </button>
);
